import { Coordinate, LatLng } from '@/lib/types/driver-location';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface PassengerLocationCache {
    coordinate: Coordinate;
    resolvedAddress: string | null;
    resolvedAt: number;
}

export interface LocationStore {
    origin: LatLng | null;
    destination: LatLng | null;
    coordinate: Coordinate | null;
    driverCoordinate: Coordinate | null;
    resolvedAddress: string | null;
    resolvedAt: number | null;
    setOrigin: (state: LatLng) => void;
    setDestination: (state: LatLng) => void;
    setCoordinate: (state: Coordinate) => void;
    setDriverCoordinate: (state: Coordinate) => void;
    setPassengerLocation: (state: PassengerLocationCache) => void;
    clearLocation: () => void;
};

export const useLocationStore = create<LocationStore>()(
    persist(
        (set) => ({
            origin: null,
            destination: null,
            coordinate: null,
            driverCoordinate: null,
            resolvedAddress: null,
            resolvedAt: null,
            setOrigin: (origin: LatLng) => set({ origin }),
            setDestination: (destination: LatLng) => set({ destination }),
            setCoordinate: (coordinate: Coordinate) => set({ coordinate }),
            setDriverCoordinate: (driverCoordinate: Coordinate) => set({ driverCoordinate }),
            setPassengerLocation: ({ coordinate, resolvedAddress, resolvedAt }) =>
                set({ coordinate, resolvedAddress, resolvedAt }),
            clearLocation: () =>
                set(() => ({
                    destination: null,
                    coordinate: null,
                    driverCoordinate: null,
                    resolvedAddress: null,
                    resolvedAt: null,
                })),
        }),
        {
            name: 'user-location',
            storage: createJSONStorage(() => AsyncStorage),
            partialize: (state) => ({
                origin: state.origin,
                destination: state.destination,
                coordinate: state.coordinate,
            }),
        },
    ),
);

export const useLocation = () => useLocationStore((state) => state.origin);
